import {UISelectionBuilder} from "./u-i-selection-builder";
import {UISelection} from "../u-i-selection";
import cmp from "../../context/context";

export class UISelectionBuilderDefaultRejected extends UISelectionBuilder {
    /* STATIC */

    /* INSTANCE */
    public constructor() {
        super();
    }

    public override build(): UISelection {
        const need = !cmp().consentAcquired;
        return new UISelection(
            {
                purposes: {
                    available: cmp().vendorList?.purposesIds()??[],
                    setted: cmp().purposes().map(purpose => {
                        return {
                            id: purpose.id,
                            selected: purpose.accepted||(need ? undefined : false),
                        }
                    })
                },
                specialFeatures: {
                    available: cmp().vendorList?.specialFeaturesIds()??[],
                    setted: cmp().specialFeatures().map(feature => {
                        return {
                            id: feature.id,
                            selected: feature.accepted||(need ? undefined : false),
                        }
                    })
                },
                purposesLI: {
                    available: cmp().vendorList?.purposesLIIds()??[],
                    setted: cmp().purposesLI().map(purpose => {
                        return {
                            id: purpose.id,
                            selected: purpose.accepted||(need ? undefined : false),
                        }
                    })
                },
                vendors: {
                    available: cmp().vendorList?.vendorIds()??[],
                    setted: cmp().vendors().map(vendor => {
                        return {
                            id: vendor.id,
                            selected: vendor.accepted||(need ? undefined : false),
                        }
                    })
                },
                vendorsLI: {
                    available: cmp().vendorList?.vendorLIIds()??[],
                    setted: cmp().vendorsLI().map(vendor => {
                        return {
                            id: vendor.id,
                            selected: vendor.accepted||(need ? undefined : false),
                        }
                    })
                },
                additionalVendors: {
                    available: cmp().vendorList?.additionalVendorsIds()??[],
                    setted: cmp().additionalVendors().map(vendor => {
                        return {
                            id: vendor.id,
                            selected: vendor.accepted||(need ? undefined : false),
                        }
                    })
                },
                customVendors: {
                    available: cmp().vendorList?.customVendorsIds()??[],
                    setted: cmp().customVendors().map(vendor => {
                        return {
                            id: vendor.id,
                            selected: vendor.accepted||(need ? undefined : false),
                        }
                    })
                }
            }

        );
    }
}
